
import Vue from 'vue';

import { mapState } from 'pinia';
import { useStore as useNotificationStore } from '@/stores/notification';
import { useStore as useProductStore } from '@/stores/product';
import SmallDetailsNotification from './SmallDetailsNotification.vue';

export default Vue.extend({
  name: 'SmallDetailsMonitor',

  components: {
    SmallDetailsNotification,
  },

  computed: {
    ...mapState(useNotificationStore, ['notificationsForBell']),
    ...mapState(useProductStore, ['selectedPrintPosition']),
    notifications() {
      // Remove creating unique notification list, after issue with duplicating text's notification is resolved
      const allNotifications = this.notificationsForBell.filter(
        (x) =>
          x.validatorName === 'smallDetails' &&
          x.printPositionId === this.selectedPrintPosition.id
      );
      return [
        ...new Map(allNotifications.map((x) => [x['payloadId'], x])).values(),
      ];
    },
  },
});
